// extracted by mini-css-extract-plugin
module.exports = {"root":"MessageEditor_root__3tGtE","editorWrap":"MessageEditor_editorWrap__2wVNa","toolbar":"MessageEditor_toolbar__Crq-S"};